<template>
  <div class="tabs">
    <el-tabs
      v-model="activeName" type="border-card"
      @tab-click="handleTabClick"
    >
      <el-tab-pane
        v-if="isBillReview"
        :label="$t('basicData.expressBill')" name="BillReview" lazy
      >
        <div v-if="activeName === 'BillReview'">
          <BillReview ref="BillReview" />
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-if="isTrunkLine"
        :label="$t('basicData.trunkLineBill')" name="TrunkLine" lazy
      >
        <div v-if="activeName === 'TrunkLine'">
          <TrunkLine ref="TrunkLine" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BillReview from './BillReview';
import TrunkLine from './TrunkLine';

export default {
  name: 'Tabs',

  components: {
    BillReview,
    TrunkLine
  },
  data() {
    return {
      activeName: 'BillReview'
    };
  },
  computed: {
    isBillReview() {
      return this.$store.getters.button_permissions.includes('btn:finance:accountsPayableReview:billReview:index');
    },
    isTrunkLine() {
      return this.$store.getters.button_permissions.includes('btn:finance:accountsPayableReview:trunkLine:index');
    }
  },
  methods: {
    handleTabClick(tab) {
      // 标签页切换时的回调
      this.$nextTick(() => {
        // 调用当前激活组件的特定方法
        const activeComponent = this.$refs[tab.name];
        if (activeComponent && typeof activeComponent.onTabActivated === 'function') {
          activeComponent.onTabActivated();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs {
  border: none;
}

::v-deep .el-tabs--border-card>.el-tabs__content {
  padding: 0;
}
</style>
